import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslatePipe } from "@ngx-translate/core";
import { CollectionRendererComponent } from './collection-renderer.component';

@NgModule({
  declarations: [ CollectionRendererComponent ],
  exports: [ CollectionRendererComponent ],
  imports: [
    CommonModule,
    TranslateModule
  ],
  providers: [
    TranslatePipe
  ]
})
export class CollectionRendererModule { }
